<template>
  <div class="flex items-center ">
    <button
      v-for="star in 5"
      :key="`star-${star}`"
      class="focus:outline-none"
      type="button"
      :disabled="disabled"
      @click="emit('update:modelValue', star)"
    >
      <StarIcon
        class="size-4 md:size-6"
        :class="{ 'fill-yellow-300': modelValue >= star, 'fill-gray-300': modelValue < star }"
      />
    </button>
    <template v-if="withInput">
      <Field
        :value="modelValue"
        :name="name"
        :label="label"
        hidden
        :rules="{ required: true }"
      />
      <ErrorMessage
        :name="name"
        class="text-xs text-red-500 md:text-sm"
      />
    </template>
  </div>
</template>
<script setup lang="ts">
import { StarIcon } from '@heroicons/vue/24/solid';
import { Field, ErrorMessage } from 'vee-validate';

interface StarReviewProps {
  modelValue: number;
  disabled?: boolean
  withInput?: boolean;
  name?: string;
  label?: string;
}

withDefaults(defineProps<StarReviewProps>(), {
  disabled: false,
  withInput: true,
  name: 'rating',
  label: 'Calificación',
});

const emit = defineEmits<{(e: 'update:modelValue', value: number): void}>();
</script>
